export const cameraConfigs = {
  motorcycle: {
    "Top Panel": { position: [1.36, 1.49, 2.52], target: [-0.03, 0.05, -0.01] },
    Ribs: {
      position: [0.76, 1.16, 1.96],
      target: [0, 0, 0],
      condition: (snap) => snap.initialChoices.ribLimit > 0,
    },
    "Side Logo": { position: [0.78, 0.57, 0.86], target: [-0.02, -0.08, 0.1] },
    "Top Logo": { position: [0.62, 1.04, 1.17], target: [-0.17, -0.31, 0.07] },
    "Race Number": {
      position: [0.17, 0.91, 0.41],
      target: [0.05, 0.34, -0.19],
    },
    Badge: { position: [0.29, 0.43, 0.65], target: [-0.04, -0.04, 0.31] },
    default: { position: [2.34, 2.38, 2.38], target: [-0.02, 0.06, -0.04] },
  },
  atv: {
    "Top Panel": { position: [1.99, 2.6, 1.98], target: [-0.03, 0.03, -0.01] },
    Ribs: {
      position: [0.77, 1.09, 2.0],
      target: [0.01, -0.07, 0.04],
      condition: (snap) => snap.initialChoices.ribLimit > 0,
    },
    "Side Logo": { position: [0.82, 0.52, 0.85], target: [0.02, -0.13, 0.09] },
    "Top Logo": { position: [0.34, 0.64, 0.89], target: [-0.16, -0.32, 0.07] },

    "Race Number": {
      position: [0.58, 0.43, 0.61],
      target: [0.16, 0.22, -0.09],
    },
    Badge: { position: [0.29, 0.43, 0.65], target: [-0.04, -0.04, 0.31] },
    default: { position: [2.21, 2.03, 1.7], target: [-0.03, 0.03, -0.01] },
  },
  //   modelB: {
  //     "Top Panel":  { position: [...], target: [...] },
  //     // ...
  //     default:      { position: [...], target: [...] },
  //   },

  ebike1: {
    "Top Panel": { position: [2.15, 1.91, 1.91], target: [0.01, -0.04, 0.0] },
    Ribs: {
      position: [1.64, 1.27, 1.95],
      target: [-0.02, -0.09, 0.08],
      condition: (snap) => snap.initialChoices.ribLimit > 0,
    },
    "Side Logo": { position: [1.3, 0.86, 0.88], target: [-0.0, -0.1, 0.08] },
    "Top Logo": { position: [0.63, 0.91, 1.0], target: [-0.08, -0.12, 0.23] },

    "Race Number": { position: [0.6, 0.61, 0.95], target: [0.1, 0.2, -0.04] },

    Badge: { position: [0.29, 0.43, 0.65], target: [-0.04, -0.04, 0.31] },
    default: { position: [2.44, 1.45, 1.95], target: [-0.01, -0.03, 0.01] },
  },
  ebike2: {
    "Top Panel": { position: [2.15, 1.91, 1.91], target: [0.01, -0.04, 0.0] },
    Ribs: {
      position: [1.64, 1.27, 1.95],
      target: [-0.02, -0.09, 0.08],
      condition: (snap) => snap.initialChoices.ribLimit > 0,
    },
    "Side Logo": { position: [1.06, 0.47, 1.03], target: [-0.01, -0.11, 0.12] },
    "Top Logo": { position: [0.64, 1.03, 1.16], target: [-0.16, -0.32, 0.07] },

    "Race Number": {
      position: [0.02, 1.57, -0.25],
      target: [-0.02, 0.12, -0.44],
    },

    Badge: { position: [0.29, 0.43, 0.65], target: [-0.04, -0.04, 0.31] },
    default: { position: [2.44, 1.45, 1.95], target: [-0.01, -0.03, 0.01] },
  },
  scooter: {
    "Top Panel": { position: [2.15, 1.91, 1.91], target: [0.01, -0.04, 0.0] },
    Ribs: {
      position: [1.35, 1.01, 1.58],
      target: [0.0, -0.09, 0.06],
      condition: (snap) => snap.initialChoices.ribLimit > 0,
    },
    "Side Logo": { position: [1.08, 0.43, 1.03], target: [0.01, -0.15, 0.12] },
    "Top Logo": { position: [0.81, 1.26, 1.38], target: [-0.14, -0.35, 0.09] },

    "Race Number": { position: [0.71, 0.65, 0.87], target: [0.13, 0.2, -0.06] },

    Badge: { position: [0.29, 0.43, 0.65], target: [-0.04, -0.04, 0.31] },
    default: { position: [2.05, 1.23, 1.64], target: [-0.01, -0.02, 0.0] },
  },

  /* ... */
};
